import { RastreioExternoComponent } from './../rastreio-externo/rastreio-externo.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  MatButtonModule,
  MatSelectModule,
  MatPaginatorModule,
  MatDatepickerModule,
  MatInputModule,
  MatDialogModule,
  MatTabsModule,
  MatTooltipModule,
  MatExpansionModule,
  MatRadioButton,
  MatRadioModule,
  MatCardModule,
  MatTreeModule,
  MatCheckboxModule,
  MatIconModule,
  MatButtonToggleModule,
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdModule } from '../md/md.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ProdutoComponent } from '../produto/produto.component';
import { ProdutosModalComponent } from './produtos-modal/produtos-modal.component';
import { ClientesModalComponent } from './clientes-modal/clientes-modal.component';
import { NgBrazil } from 'ng-brazil';
import { SelecaoModalComponent } from './selecao-modal/selecao-modal.component';
import { DetalheProdutoModalComponent } from './detalhe-produto-modal/detalhe-produto-modal.component';
import { ResumoModalComponent } from './resumo-modal/resumo-modal.component';
import { ComissoesModalComponent } from './comissoes-modal/comissoes-modal.component';
import { ResumoFinanceiroModalComponent } from './resumo-financeiro-modal/resumo-financeiro-modal.component';
import { JustificativaModalComponent } from './justificativa-modal/justificativa-modal.component';
import { MonitoramentoFuncionarioModalComponent } from './monitoramento-funcionario-modal/monitoramento-funcionario-modal.component';
import { EstoqueModalComponent } from './estoque-modal/estoque-modal.component';
import { NotaFiscalModalComponent } from './nota-fiscal-modal/nota-fiscal-modal.component';
import { MesAMesModalComponent } from './mes-ames-modal/mes-ames-modal.component';
import { VolumeModalComponent } from './volume-modal/volume-modal.component';
import { AnexoModalComponent } from './anexo-modal/anexo-modal.component';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ObsModalComponent } from './obs-modal/obs-modal.component';
import { ProdutosSelecionadosModalComponent } from './produtos-selecionados-modal/produtos-selecionados-modal.component';
import { PotenciaKitsModalComponent } from './potencia-kits-modal/potencia-kits-modal.component';
import { DigitaCampoModalComponent } from './digita-campo-modal/digita-campo-modal.component';
import { MenuModalComponent } from './menu-modal/menu-modal.component';
import { FuncionariosModalComponent } from './funcionarios-modal/funcionarios-modal.component';
import { FunilModalComponent } from './funil-modal/funil-modal.component';
import { ObservacoesModalComponent } from './observacoes-modal/observacoes-modal.component';
import { DetalheEstruturaModalComponent } from './detalhe-estrutura-modal/detalhe-estrutura-modal.component';
import { LayoutModalComponent } from './layout-modal/layout-modal.component';
import { ComposicaoKitModalComponent } from './composicao-kit-modal/composicao-kit-modal.component';
import { CadastrarComposicaoKitModalComponent } from './composicao-kit-modal/cadastrar-composicao-kit-modal/cadastrar-composicao-kit-modal.component';
import { SelecionaProdutoModalComponent } from './seleciona-produto-modal/seleciona-produto-modal.component';
import { CadastraCombinacaoModalComponent } from './cadastra-combinacao-modal/cadastra-combinacao-modal.component';
import { KitsSugeridosModalComponent } from './kits-sugeridos-modal/kits-sugeridos-modal.component';
import { IrradiacaoModalComponent } from './irradiacao-modal/irradiacao-modal.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ImportarProdutosModalComponent } from './importar-produtos-modal/importar-produtos-modal.component';
import { ImportarLotesModalComponent } from './importar-lotes-modal/importar-lotes-modal.component';
import { VendaItemLotesModalComponent } from './venda-item-lotes-modal/venda-item-lotes-modal.component';
import { ImportarTabelaDeFretesModalComponent } from './importar-tabela-de-fretes-modal/importar-tabela-de-fretes-modal.component';
import { EditaTabelaDeFretesModalComponent } from './edita-tabela-de-fretes-modal/edita-tabela-de-fretes-modal.component';
import { SelecionaKitModalComponent } from './seleciona-kit-modal/seleciona-kit-modal.component';
import { ProdutoFidelidadeModalComponent } from './produto-fidelidade-modal/produto-fidelidade-modal.component';
import { CadastrarProdutoFidelidadeModalComponent } from './produto-fidelidade-modal/cadastrar-produto-fidelidade-modal/cadastrar-produto-fidelidade-modal.component';
import { PontosFidelidadeModalComponent } from './pontos-fidelidade-modal/pontos-fidelidade-modal.component';
import { CadastrarPontosFidelidadeModalComponent } from './pontos-fidelidade-modal/cadastrar-pontos-fidelidade-modal/cadastrar-pontos-fidelidade-modal.component';
import { ModelosDeDownloadModalComponent } from './modelos-de-download-modal/modelos-de-download-modal.component';
import { NotaFiscalPedidoModalComponent } from './nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { AtualizarProdutosModalComponent } from './atualizar-produtos-modal/atualizar-produtos-modal.component';
import { SelecionarStatusOrcamentoModalComponent } from './selecionar-status-orcamento-modal/selecionar-status-orcamento-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { VisualizadorPdfComponent } from '../visualizador-pdf/visualizador-pdf.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ResgatarPontosModalComponent } from './resgatar-pontos-modal/resgatar-pontos-modal.component';
import { VendaEnderecoModalComponent } from './venda-endereco-modal/venda-endereco-modal.component';
import { VendaDiretaModalComponent } from './venda-direta-modal/venda-direta-modal.component';
import { MotivoPerdaOrcModalComponent } from './motivo-perda-orc-modal/motivo-perda-orc-modal.component';
import { MentionModule } from 'angular-mentions';
import { CadastrarPedidoAnexoComponent } from '../pedido/pedido-anexo/cadastrar-pedido-anexo/cadastrar-pedido-anexo.component';
import { PedidoAnexoComponent } from '../pedido/pedido-anexo/pedido-anexo.component';
import { PopoverModule } from 'ngx-smart-popover';
import { ClassificacaoModalComponent } from './classificacao-modal/classificacao-modal.component';
import { CadastrarClassificacaoModalComponent } from './classificacao-modal/cadastrar-classificacao-modal/cadastrar-classificacao-modal.component';
import { IconesModalComponent } from './icones-modal/icones-modal.component';
import { SelecionarTagModalComponent } from './selecionar-tag-modal/selecionar-tag-modal.component';
import { PedidoRecebimentoModalComponent } from './pedido-recebimento-modal/pedido-recebimento-modal.component';
import { CadastrarPedidoRecebimentoModalComponent } from './pedido-recebimento-modal/cadastrar-pedido-recebimento-modal/cadastrar-pedido-recebimento-modal.component';
import { AtualizaCepModalComponent } from './atualiza-cep-modal/atualiza-cep-modal.component';
import { CodFinameModalComponent } from './cod-finame-modal/cod-finame-modal.component';
import { CupomDescontoModalComponent } from './cupom-desconto-modal/cupom-desconto-modal.component';
import { ProdutoFechamentoModalComponent } from './produto-fechamento-modal/produto-fechamento-modal.component';
import { PedidosFechamentoComponent } from './pedidos-fechamento/pedidos-fechamento.component';
import { SelecionarStatusFechamentoComponent } from './selecionar-status-fechamento/selecionar-status-fechamento.component';
import { ProdutoPedidoModalComponent } from './produto-pedido-modal/produto-pedido-modal.component';
import { SelecionarOcorrenciaModalComponent } from './selecionar-ocorrencia-modal/selecionar-ocorrencia-modal.component';
import { CadastrarOcorrenciaTipoModalComponent } from './ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal.component';
import { OcorrenciaTipoModalComponent } from './ocorrencia-tipo-modal/ocorrencia-tipo-modal.component';
import { AnexoCadastroModalComponent } from './anexo-cadastro-modal/anexo-cadastro-modal.component';
import { CadastrarAnexoCadastroModalComponent } from './anexo-cadastro-modal/cadastrar-anexo-cadastro-modal/cadastrar-anexo-cadastro-modal.component';
import { ContatoAnexoModalComponent } from './contato-anexo-modal/contato-anexo-modal.component';
import { CadastrarContatoAnexoModalComponent } from './contato-anexo-modal/cadastrar-contato-anexo-modal/cadastrar-contato-anexo-modal.component';
import { InserirValorModalComponent } from './inserir-valor-modal/inserir-valor-modal.component';
import { TransportadoraModalComponent } from './transportadora-modal/transportadora-modal.component';
import { CadastrarTransportadoraModalComponent } from './transportadora-modal/cadastrar-transportadora-modal/cadastrar-transportadora-modal.component';

import { DirectivesModule } from '../directives/directives.module';
import { CnaeErroModalComponent } from './cnae-erro-modal/cnae-erro-modal.component';
import { CadastrarCnaeModalComponent } from './cnae-modal/cadastrar-cnae-modal/cadastrar-cnae-modal.component';
import { CnaeModalComponent } from './cnae-modal/cnae-modal.component';
import { GerenciarColunasCarteiraIntegradoresModalComponent } from './gerenciar-colunas-carteira-integradores-modal/gerenciar-colunas-carteira-integradores-modal.component';
import { GerenciarFiltrosCarteiraIntegradoresModalComponent } from './gerenciar-filtros-carteira-integradores-modal/gerenciar-filtros-carteira-integradores-modal.component';
import { SelecionarConsultaCarteiraIntegradoresModalComponent } from './selecionar-consulta-carteira-integradores-modal/selecionar-consulta-carteira-integradores-modal.component';
import { DadosDoIntegradorCarteiraIntegradoresModalComponent } from './dados-do-integrador-carteira-integradores-modal/dados-do-integrador-carteira-integradores-modal.component';
import { AtividadeModalComponent } from './atividade-modal/atividade-modal.component';
import { CadastroAtividadeModalComponent } from './atividade-modal/cadastro-atividade-modal/cadastro-atividade-modal.component';
import { ArquivoPropostaModalComponent } from './arquivo-proposta-modal/arquivo-proposta-modal.component';
import { FileUploadModule } from 'ng2-file-upload';
import { VariaveisArquivoPropostaModalComponent } from './variaveis-arquivo-proposta-modal/variaveis-arquivo-proposta-modal.component';
import { ArquivoTermoModalComponent } from './arquivo-termo-modal/arquivo-termo-modal.component';
import { AtualizarPrevisaoEntregaModalComponent } from './atualizar-previsao-entrega-modal/atualizar-previsao-entrega-modal.component';
import { CadastroTabelaPersonalizadaModalComponent } from './cadastro-tabela-personalizada-modal/cadastro-tabela-personalizada-modal.component';
import { CadastroOpcaoTabelaPersonalizadaModalComponent } from './cadastro-opcao-tabela-personalizada-modal/cadastro-opcao-tabela-personalizada-modal.component';
import { GerenciarClassificacaoPersonalizadaModalComponent } from './gerenciar-classificacao-personalizada-modal/gerenciar-classificacao-personalizada-modal.component';
import { CadastrarVoucherModalComponent } from './cadastrar-voucher-modal/cadastrar-voucher-modal.component';
import { SelecionarVoucherModalComponent } from './selecionar-voucher-modal/selecionar-voucher-modal.component';
import { VoucherComponent } from '../voucher/voucher.component';
import { CondicoesVoucherModalComponent } from './condicoes-voucher-modal/condicoes-voucher-modal.component';
import { CadastrarVoucherAutomaticoModalComponent } from './cadastrar-voucher-automatico-modal/cadastrar-voucher-automatico-modal.component';
import { SelecionarArquivoBoletoPedidoModalComponent } from './selecionar-arquivo-boleto-pedido-modal/selecionar-arquivo-boleto-pedido-modal.component';
import { MicInvCombModalComponent } from './mic-inv-comb-modal/mic-inv-comb-modal.component';
import { InfoRegrasModalComponent } from './info-regras-modal/info-regras-modal.component';
import { UploadArquivoComponent } from '../upload-arquivo/upload-arquivo.component';
import { VariaveisArquivoContratoModalComponent } from './variaveis-arquivo-contrato-modal/variaveis-arquivo-contrato-modal.component';
import { CadastrarFaixaFreteModalComponent } from './cadastrar-faixa-frete-modal/cadastrar-faixa-frete-modal.component';
import { FaixaFreteModalComponent } from './faixa-frete-modal/faixa-frete-modal.component';
import { TelasModalComponent } from './telas-modal/telas-modal.component';
import { ArquivoResumoPedidoModalComponent } from './arquivo-resumo-pedido-modal/arquivo-resumo-pedido-modal.component';
import { VariaveisArquivoResumoPedidoModalComponent } from './variaveis-arquivo-resumo-pedido-modal/variaveis-arquivo-resumo-pedido-modal.component';
import { ItemConversaModalComponent } from './item-conversa-modal/item-conversa-modal.component';
import { CadastrarItemConversaModalComponent } from './cadastrar-item-conversa-modal/cadastrar-item-conversa-modal.component';
import { CadastrarLigacaoTelemarketingModalComponent } from './cadastrar-ligacao-telemarketing-modal/cadastrar-ligacao-telemarketing-modal.component';
import { CadastrarFornecedorEstruturaModalComponent } from './cadastrar-fornecedor-estrutura-modal/cadastrar-fornecedor-estrutura-modal.component';
import { FormulaItemEstruturaModalComponent } from './formula-item-estrutura-modal/formula-item-estrutura-modal.component';
import { TextInputHighlightModule } from 'angular-text-input-highlight';
import { SimulacaoEstruturaModalComponent } from './simulacao-estrutura-modal/simulacao-estrutura-modal.component';
import { InfoRegrasEstruturaModalComponent } from './info-regras-estrutura-modal/info-regras-estrutura-modal.component';
import { ClonarEstruturaModalComponent } from './clonar-estrutura-modal/clonar-estrutura-modal.component';
import { QuestionarioEntregaModalComponent } from './questionario-entrega-modal/questionario-entrega-modal.component';
import { CadastrarQuestionarioEntregaModalComponent } from './cadastrar-questionario-entrega-modal/cadastrar-questionario-entrega-modal.component';
import { MaxPainelModalComponent } from './max-painel-modal/max-painel-modal.component';
import { CadastrarMaxPainelModalComponent } from './cadastrar-max-painel-modal/cadastrar-max-painel-modal.component';
import { FormulaVariavelModalComponent } from './formula-variavel-modal/formula-variavel-modal.component';
import { VariavelPersonalizadaModalComponent } from './variavel-personalizada-modal/variavel-personalizada-modal.component';
import { AlterarValorSeguroModalComponent } from './alterar-valor-seguro-modal/alterar-valor-seguro-modal.component';
import { FidelidadeEmailComponent } from '../fidelidade-email/fidelidade-email.component';
import { CadastrarFidelidadeEmailComponent } from '../fidelidade-email/cadastrar-fidelidade-email/cadastrar-fidelidade-email.component';
import { DescontoIndividualModalComponent } from './desconto-individual-modal/desconto-individual-modal.component';
import { ItemSimFinModalComponent } from './item-sim-fin-modal/item-sim-fin-modal.component';
import { MultiFormaPagamentoModalComponent } from './multi-forma-pagamento-modal/multi-forma-pagamento-modal.component';
import { CadastrarMultiFormaPagamentoModalComponent } from './multi-forma-pagamento-modal/cadastrar-multi-forma-pagamento-modal/cadastrar-multi-forma-pagamento-modal.component';
import { LigacaoModalComponent } from './ligacao-modal/ligacao-modal.component';
import { TagHistoricoModalComponent } from './tag-historico-modal/tag-historico-modal.component';
import { ComposicaoKitAutomaticoModalComponent } from './composicao-kit-automatico-modal/composicao-kit-automatico-modal.component';
import { KitImagemModalComponent } from './kit-imagem-modal/kit-imagem-modal.component';
import { CadastrarKitImagemModalComponent } from './kit-imagem-modal/cadastrar-kit-imagem-modal/cadastrar-kit-imagem-modal.component';
import { DadosMonitoresModalComponent } from './dados-monitores-modal/dados-monitores-modal.component';
import { SignatariosModalComponent } from './signatarios-modal/signatarios-modal.component';
import { CadastrarSignatarioModalComponent } from './cadastrar-signatario-modal/cadastrar-signatario-modal.component';
import { EstoqueProdutoModalComponent } from './estoque-produto-modal/estoque-produto-modal.component';
import { PedidosLoteModalComponent } from './pedidos-lote-modal/pedidos-lote-modal.component';
import { MeiosDePagamentoModalComponent } from './meios-de-pagamento-modal/meios-de-pagamento-modal.component';
import { AlterarMargemValorFornecedorModalComponent } from './alterar-margem-valor-fornecedor-modal/alterar-margem-valor-fornecedor-modal.component';
import { AlterarLiderTimeModalComponent } from './alterar-lider-time-modal/alterar-lider-time-modal.component';
import { HistoricoDoPrecoModalComponent } from './historico-do-preco-modal/historico-do-preco-modal.component';
import { KitsParaExcluirModalComponent } from './kits-para-excluir-modal/kits-para-excluir-modal.component';
import { OcorrenciaLogRespModalComponent } from './ocorrencia-log-resp-modal/ocorrencia-log-resp-modal.component';
import { PedidoApelidoModalComponent } from './pedido-apelido-modal/pedido-apelido-modal.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ContaRefModalComponent } from './conta-ref-modal/conta-ref-modal.component';
import { ProdutoCDModalComponent } from './produto-cdmodal/produto-cdmodal.component';
import { AnotacaoStatusModalComponent } from './anotacao-status-modal/anotacao-status-modal.component';
import { SelecionarEtapaPedidoModalComponent } from './selecionar-etapa-pedido-modal/selecionar-etapa-pedido-modal.component';
import { FiltrosGestaoDeDescontosComponent } from './filtros-gestao-de-descontos/filtros-gestao-de-descontos.component';
import { ListaGestaoDescontoComponent } from './lista-gestao-desconto/lista-gestao-desconto.component';
import { LogFiltrosGestaoDescComponent } from './log-filtros-gestao-desc/log-filtros-gestao-desc.component';
import { FiltroClassificacaoPedidosComponent } from './filtro-classificacao-pedidos/filtro-classificacao-pedidos.component';
import { CadastrarSetorModalComponent } from './cadastrar-setor-modal/cadastrar-setor-modal.component';
import { ConfiguraAppOctopusComponent } from './configura-app-octopus/configura-app-octopus.component';
import { CustomFormlyModule } from '../formly/formly-module';
import { PagamentoOctopusComponent } from './pagamento-octopus/pagamento-octopus.component';
import { ClipboardModule } from 'ngx-clipboard';
import { LotesDoProdutoModalComponent } from './lotes-do-produto-modal/lotes-do-produto-modal.component';
import { TrocarDeLoteModalComponent } from './trocar-de-lote-modal/trocar-de-lote-modal.component';
import { AdicionarMenuProdutoModalComponent } from './adicionar-menu-produto-modal/adicionar-menu-produto-modal.component';
import { TokenPlataformaModalComponent } from './token-plataforma-modal/token-plataforma-modal.component';
import { HistoricoEstoqueModalComponent } from './historico-estoque-modal/historico-estoque-modal.component';
import { CadastrarPendenciaModalComponent } from './cadastrar-pendencia-modal/cadastrar-pendencia-modal.component';
import { TransferenciaItemsVendedorModalComponent } from './transferencia-items-vendedor-modal/transferencia-items-vendedor-modal.component';
import { CadastrarNotaFiscalPedidoModalComponent } from './nota-fiscal-pedido-modal/cadastrar-nota-fiscal-pedido-modal/cadastrar-nota-fiscal-pedido-modal.component';
import { ExportarFretesMultiCDsModalComponent } from './exportar-fretes-multi-cds-modal/exportar-fretes-multi-cds-modal.component';
import { SolicitacoesTokenIntegradorModalComponent } from './solicitacoes-token-integrador-modal/solicitacoes-token-integrador-modal.component';
import { IntegradorModalComponent } from './integrador-modal/integrador-modal.component';
import { BIModule } from '../bi/bimodule/bi.module';
import { PrecificacaoUFModalComponent } from './precificacao-ufmodal/precificacao-ufmodal.component';
import { CadastrarPrecificacaoUFModalComponent } from './precificacao-ufmodal/cadastrar-precificacao-ufmodal/cadastrar-precificacao-ufmodal.component';
import { ModalidadeComponent } from '../modalidade/modalidade.component';
import { LogsVendaCupomModalComponent } from './logs-venda-cupom-modal/logs-venda-cupom-modal.component';
import { LogOcorrenciaComponent } from './log-ocorrencia-modal/log-ocorrencia-modal.component';
import { AnaliseDescontoSolicitacaoModalComponent } from './analise-desconto-solicitacao-modal/analise-desconto-solicitacao-modal.component';
import { AnexoUploaderModule } from '../anexo-uploader/anexo-uploader.module';
import { FilaAddOperadorModalComponent } from './fila-add-operador-modal/fila-add-operador-modal.component';
import { FilaSelOperadorModalComponent } from './fila-sel-operador-modal/fila-sel-operador-modal.component';
import { AnaliseDescontoConclusaoModalComponent } from './analise-desconto-conclusao-modal/analise-desconto-conclusao-modal.component';
import { HistoricoAnaliseDescontoModule } from '../historico-analise-desconto/historico-analise-desconto.module';
import { CadastrarEtapaOcorrenciaModalComponent } from './cadastrar-etapa-ocorrencia-modal/cadastrar-etapa-ocorrencia-modal.component';
import { LogEtapaOcorrenciaModalComponent } from './log-etapa-ocorrencia-modal/log-etapa-ocorrencia-modal.component';
import { ListaPendenciaModalComponent } from './lista-pendencia-modal/lista-pendencia-modal.component';
import { FaixaDescargaCifComponent } from './faixa-descarga-cif/faixa-descarga-cif.component';
import { CadastrarFaixaDescargaCifModalComponent } from './cadastrar-faixa-descarga-cif-modal/cadastrar-faixa-descarga-cif-modal.component';
import { CadastrarEtapaRastreioModalComponent } from './cadastrar-etapa-rastreio-modal/cadastrar-etapa-rastreio-modal.component';
import { RastreioModule } from '../rastreio/rastreio.module';
import { RastreioComponent } from '../rastreio/rastreio.component';
import { RastreioPedidoModalComponent } from './rastreio-pedido-modal/rastreio-pedido-modal.component';
import { FinanciadoraIntegradorModule } from '../financiadora-integrador/financiadora-integrador.module';
import { FornecedorModalComponent } from './fornecedor-modal/fornecedor-modal.component';
import { ImportarAgrupamentoStringboxModalComponent } from './importar-agrupamento-stringbox-modal/importar-agrupamento-stringbox-modal.component';
import { TermoAceiteModalComponent } from './termo-aceite-modal/termo-aceite-modal.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialModule } from '../material.module';
import { CoreSharedModule } from '../core/core-shared.module';
import { IndicadoresAnaliseDescontoModalComponent } from './indicadores-analise-desconto-modal/indicadores-analise-desconto-modal.component';
import { CadastrarAgrupamentoStringboxModalComponent } from './cadastrar-agrupamento-stringbox-modal/cadastrar-agrupamento-stringbox-modal.component';
import { TermoAceiteListaModalComponent } from './termo-aceite-lista-modal/termo-aceite-lista-modal.component';
import { ProdutosV2ModalComponent } from './produtos-v2-modal/produtos-v2-modal.component';
import { QuillModule } from 'ngx-quill';
import { SelecionaProdutoV2ModalComponent } from './seleciona-produto-v2-modal/seleciona-produto-v2-modal.component';
import { EnviarEmailModalComponent } from './enviar-email-modal/enviar-email-modal.component';
import { ImportarTransferenciaVendedoresModalComponent } from './importar-transferencia-vendedores-modal/importar-transferencia-vendedores-modal.component';
import { MultiFormaPagamentoModule } from '../multi-forma-pagamento/multi-forma-pagamento.module';
import { NovaSimulacaoModalComponent } from './nova-simulacao-modal/nova-simulacao-modal.component';
import { VendaDiretaModule } from '../venda-direta/venda-direta.module';
import { VendaEntregaModule } from '../venda-entrega/venda-entrega.module';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  imports: [
    QRCodeModule,
    RouterModule,
    CommonModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    MatCardModule,
    MdModule,
    MatSelectModule,
    MatExpansionModule,
    MatRadioModule,
    MatPaginatorModule,
    NgSelectModule,
    PerfectScrollbarModule,
    MatDatepickerModule,
    MatInputModule,
    MatDialogModule,
    MatTabsModule,
    MatTooltipModule,
    TextInputHighlightModule,
    CurrencyMaskModule,
    NgBrazil,
    TextMaskModule,
    NgxMaskModule.forRoot(options),
    NgxChartsModule,
    NgxExtendedPdfViewerModule,
    LazyLoadImageModule,
    MentionModule,
    PopoverModule,
    DirectivesModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    CustomFormlyModule,
    ClipboardModule,
    BIModule,
    AnexoUploaderModule,
    HistoricoAnaliseDescontoModule,
    MatButtonToggleModule,
    RastreioModule,
    FinanciadoraIntegradorModule,
    NgxSpinnerModule,
    MaterialModule,
    CoreSharedModule,
    QuillModule.forRoot(),
    MultiFormaPagamentoModule,
    VendaDiretaModule,
    VendaEntregaModule,
  ],
  declarations: [
    ProdutoComponent,
    ProdutosModalComponent,
    ProdutosV2ModalComponent,
    ClientesModalComponent,
    SelecaoModalComponent,
    DetalheProdutoModalComponent,
    ResumoModalComponent,
    ComissoesModalComponent,
    ResumoFinanceiroModalComponent,
    JustificativaModalComponent,
    MonitoramentoFuncionarioModalComponent,
    EstoqueModalComponent,
    NotaFiscalModalComponent,
    MesAMesModalComponent,
    VolumeModalComponent,
    AnexoModalComponent,
    ObsModalComponent,
    ProdutosSelecionadosModalComponent,
    PotenciaKitsModalComponent,
    DigitaCampoModalComponent,
    MenuModalComponent,
    FuncionariosModalComponent,
    FunilModalComponent,
    ObservacoesModalComponent,
    DetalheEstruturaModalComponent,
    LayoutModalComponent,
    ComposicaoKitModalComponent,
    CadastrarComposicaoKitModalComponent,
    SelecionaProdutoModalComponent,
    CadastraCombinacaoModalComponent,
    KitsSugeridosModalComponent,
    IrradiacaoModalComponent,
    ImportarProdutosModalComponent,
    ImportarLotesModalComponent,
    ImportarTabelaDeFretesModalComponent,
    EditaTabelaDeFretesModalComponent,
    SelecionaKitModalComponent,
    ProdutoFidelidadeModalComponent,
    CadastrarProdutoFidelidadeModalComponent,
    PontosFidelidadeModalComponent,
    CadastrarPontosFidelidadeModalComponent,
    ModelosDeDownloadModalComponent,
    NotaFiscalPedidoModalComponent,
    AtualizarProdutosModalComponent,
    SelecionarStatusOrcamentoModalComponent,
    VisualizadorPdfComponent,
    ResgatarPontosModalComponent,
    VendaEnderecoModalComponent,
    VendaDiretaModalComponent,
    MotivoPerdaOrcModalComponent,
    PedidoAnexoComponent,
    CadastrarPedidoAnexoComponent,
    HistoricoDoPrecoModalComponent,
    AlterarLiderTimeModalComponent,
    AtualizaCepModalComponent,
    CodFinameModalComponent,
    CupomDescontoModalComponent,
    ClassificacaoModalComponent,
    CadastrarClassificacaoModalComponent,
    IconesModalComponent,
    SelecionarTagModalComponent,
    PedidoRecebimentoModalComponent,
    CadastrarPedidoRecebimentoModalComponent,
    ProdutoFechamentoModalComponent,
    PedidosFechamentoComponent,
    SelecionarStatusFechamentoComponent,
    ProdutoPedidoModalComponent,
    SelecionarOcorrenciaModalComponent,
    CadastrarOcorrenciaTipoModalComponent,
    OcorrenciaTipoModalComponent,
    AnexoCadastroModalComponent,
    CadastrarAnexoCadastroModalComponent,
    ContatoAnexoModalComponent,
    CadastrarContatoAnexoModalComponent,
    InserirValorModalComponent,
    TransportadoraModalComponent,
    CadastrarTransportadoraModalComponent,
    CadastrarCnaeModalComponent,
    CnaeModalComponent,
    CnaeErroModalComponent,
    GerenciarColunasCarteiraIntegradoresModalComponent,
    GerenciarFiltrosCarteiraIntegradoresModalComponent,
    SelecionarConsultaCarteiraIntegradoresModalComponent,
    DadosDoIntegradorCarteiraIntegradoresModalComponent,
    AtividadeModalComponent,
    CadastroAtividadeModalComponent,
    ArquivoPropostaModalComponent,
    VariaveisArquivoPropostaModalComponent,
    ArquivoTermoModalComponent,
    AtualizarPrevisaoEntregaModalComponent,
    CadastroTabelaPersonalizadaModalComponent,
    CadastroOpcaoTabelaPersonalizadaModalComponent,
    GerenciarClassificacaoPersonalizadaModalComponent,
    CadastrarVoucherModalComponent,
    SelecionarVoucherModalComponent,
    VoucherComponent,
    CondicoesVoucherModalComponent,
    CadastrarVoucherAutomaticoModalComponent,
    SelecionarArquivoBoletoPedidoModalComponent,
    MicInvCombModalComponent,
    InfoRegrasModalComponent,
    UploadArquivoComponent,
    VariaveisArquivoContratoModalComponent,
    CadastrarFaixaFreteModalComponent,
    FaixaFreteModalComponent,
    TelasModalComponent,
    ArquivoResumoPedidoModalComponent,
    VariaveisArquivoResumoPedidoModalComponent,
    ItemConversaModalComponent,
    CadastrarItemConversaModalComponent,
    CadastrarLigacaoTelemarketingModalComponent,
    CadastrarFornecedorEstruturaModalComponent,
    FormulaItemEstruturaModalComponent,
    SimulacaoEstruturaModalComponent,
    InfoRegrasEstruturaModalComponent,
    ClonarEstruturaModalComponent,
    QuestionarioEntregaModalComponent,
    CadastrarQuestionarioEntregaModalComponent,
    MaxPainelModalComponent,
    CadastrarMaxPainelModalComponent,
    FormulaVariavelModalComponent,
    VariavelPersonalizadaModalComponent,
    AlterarValorSeguroModalComponent,
    DescontoIndividualModalComponent,
    ItemSimFinModalComponent,
    MultiFormaPagamentoModalComponent,
    CadastrarMultiFormaPagamentoModalComponent,
    LigacaoModalComponent,
    TagHistoricoModalComponent,
    ComposicaoKitAutomaticoModalComponent,
    KitImagemModalComponent,
    CadastrarKitImagemModalComponent,
    FidelidadeEmailComponent,
    CadastrarFidelidadeEmailComponent,
    DadosMonitoresModalComponent,
    SignatariosModalComponent,
    CadastrarSignatarioModalComponent,
    EstoqueProdutoModalComponent,
    PedidosLoteModalComponent,
    MeiosDePagamentoModalComponent,
    AlterarMargemValorFornecedorModalComponent,
    KitsParaExcluirModalComponent,
    PedidoApelidoModalComponent,
    OcorrenciaLogRespModalComponent,
    ContaRefModalComponent,
    ProdutoCDModalComponent,
    AnotacaoStatusModalComponent,
    SelecionarEtapaPedidoModalComponent,
    FiltrosGestaoDeDescontosComponent,
    ListaGestaoDescontoComponent,
    LogFiltrosGestaoDescComponent,
    FiltroClassificacaoPedidosComponent,
    CadastrarSetorModalComponent,
    ConfiguraAppOctopusComponent,
    PagamentoOctopusComponent,
    LotesDoProdutoModalComponent,
    TrocarDeLoteModalComponent,
    AdicionarMenuProdutoModalComponent,
    TokenPlataformaModalComponent,
    HistoricoEstoqueModalComponent,
    CadastrarPendenciaModalComponent,
    TransferenciaItemsVendedorModalComponent,
    CadastrarNotaFiscalPedidoModalComponent,
    ExportarFretesMultiCDsModalComponent,
    PrecificacaoUFModalComponent,
    CadastrarPrecificacaoUFModalComponent,
    SolicitacoesTokenIntegradorModalComponent,
    IntegradorModalComponent,
    ModalidadeComponent,
    LogsVendaCupomModalComponent,
    LogOcorrenciaComponent,
    AnaliseDescontoSolicitacaoModalComponent,
    FilaAddOperadorModalComponent,
    FilaSelOperadorModalComponent,
    AnaliseDescontoConclusaoModalComponent,
    CadastrarEtapaOcorrenciaModalComponent,
    LogEtapaOcorrenciaModalComponent,
    ListaPendenciaModalComponent,
    FaixaDescargaCifComponent,
    CadastrarFaixaDescargaCifModalComponent,
    CadastrarEtapaRastreioModalComponent,
    RastreioExternoComponent,
    RastreioPedidoModalComponent,
    FornecedorModalComponent,
    ImportarAgrupamentoStringboxModalComponent,
    TermoAceiteModalComponent,
    IndicadoresAnaliseDescontoModalComponent,
    CadastrarAgrupamentoStringboxModalComponent,
    TermoAceiteListaModalComponent,
    SelecionaProdutoV2ModalComponent,
    ImportarTransferenciaVendedoresModalComponent,
    VendaItemLotesModalComponent,
    EnviarEmailModalComponent,
  ],
  exports: [
    ProdutosModalComponent,
    ProdutosV2ModalComponent,
    DetalheProdutoModalComponent,
    ResumoModalComponent,
    ComissoesModalComponent,
    ResumoFinanceiroModalComponent,
    VoucherComponent,
  ],
  entryComponents: [
    QuestionarioEntregaModalComponent,
    CadastrarQuestionarioEntregaModalComponent,
    ProdutosModalComponent,
    ProdutosV2ModalComponent,
    ClientesModalComponent,
    SelecaoModalComponent,
    JustificativaModalComponent,
    ItemSimFinModalComponent,
    AlterarValorSeguroModalComponent,
    VariavelPersonalizadaModalComponent,
    FormulaVariavelModalComponent,
    DetalheProdutoModalComponent,
    ResumoModalComponent,
    ComissoesModalComponent,
    ResumoFinanceiroModalComponent,
    MonitoramentoFuncionarioModalComponent,
    ComposicaoKitAutomaticoModalComponent,
    EstoqueModalComponent,
    NotaFiscalModalComponent,
    VolumeModalComponent,
    AnexoModalComponent,
    ObsModalComponent,
    ProdutosSelecionadosModalComponent,
    PotenciaKitsModalComponent,
    DigitaCampoModalComponent,
    MenuModalComponent,
    FuncionariosModalComponent,
    FunilModalComponent,
    ObservacoesModalComponent,
    DetalheEstruturaModalComponent,
    LayoutModalComponent,
    ComposicaoKitModalComponent,
    CadastrarComposicaoKitModalComponent,
    SelecionaProdutoModalComponent,
    CadastraCombinacaoModalComponent,
    KitsSugeridosModalComponent,
    IrradiacaoModalComponent,
    ImportarProdutosModalComponent,
    ImportarLotesModalComponent,
    ImportarTabelaDeFretesModalComponent,
    EditaTabelaDeFretesModalComponent,
    SelecionaKitModalComponent,
    ProdutoFidelidadeModalComponent,
    CadastrarProdutoFidelidadeModalComponent,
    PontosFidelidadeModalComponent,
    CadastrarPontosFidelidadeModalComponent,
    ModelosDeDownloadModalComponent,
    NotaFiscalPedidoModalComponent,
    AtualizarProdutosModalComponent,
    SelecionarStatusOrcamentoModalComponent,
    VisualizadorPdfComponent,
    ResgatarPontosModalComponent,
    VendaEnderecoModalComponent,
    VendaDiretaModalComponent,
    MotivoPerdaOrcModalComponent,
    PedidoAnexoComponent,
    CadastrarPedidoAnexoComponent,
    SignatariosModalComponent,
    CadastrarSignatarioModalComponent,
    CodFinameModalComponent,
    ClonarEstruturaModalComponent,
    CupomDescontoModalComponent,
    ClassificacaoModalComponent,
    CadastrarClassificacaoModalComponent,
    IconesModalComponent,
    SelecionarTagModalComponent,
    PedidoRecebimentoModalComponent,
    CadastrarPedidoRecebimentoModalComponent,
    AtualizaCepModalComponent,
    ProdutoFechamentoModalComponent,
    PedidosFechamentoComponent,
    SelecionarStatusFechamentoComponent,
    ProdutoPedidoModalComponent,
    SelecionarOcorrenciaModalComponent,
    OcorrenciaTipoModalComponent,
    CadastrarOcorrenciaTipoModalComponent,
    AnexoCadastroModalComponent,
    CadastrarAnexoCadastroModalComponent,
    ContatoAnexoModalComponent,
    CadastrarContatoAnexoModalComponent,
    InserirValorModalComponent,
    TransportadoraModalComponent,
    CadastrarTransportadoraModalComponent,
    MaxPainelModalComponent,
    CadastrarMaxPainelModalComponent,
    CadastrarCnaeModalComponent,
    CnaeModalComponent,
    CnaeErroModalComponent,
    GerenciarColunasCarteiraIntegradoresModalComponent,
    GerenciarFiltrosCarteiraIntegradoresModalComponent,
    SelecionarConsultaCarteiraIntegradoresModalComponent,
    DadosDoIntegradorCarteiraIntegradoresModalComponent,
    AtividadeModalComponent,
    CadastroAtividadeModalComponent,
    ArquivoPropostaModalComponent,
    VariaveisArquivoPropostaModalComponent,
    ArquivoTermoModalComponent,
    AtualizarPrevisaoEntregaModalComponent,
    CadastroTabelaPersonalizadaModalComponent,
    CadastroOpcaoTabelaPersonalizadaModalComponent,
    GerenciarClassificacaoPersonalizadaModalComponent,
    CadastrarVoucherModalComponent,
    SelecionarVoucherModalComponent,
    CondicoesVoucherModalComponent,
    CadastrarVoucherAutomaticoModalComponent,
    SelecionarArquivoBoletoPedidoModalComponent,
    MicInvCombModalComponent,
    InfoRegrasModalComponent,
    InfoRegrasEstruturaModalComponent,
    VariaveisArquivoContratoModalComponent,
    TelasModalComponent,
    CadastrarFaixaFreteModalComponent,
    FaixaFreteModalComponent,
    ArquivoResumoPedidoModalComponent,
    VariaveisArquivoResumoPedidoModalComponent,
    ItemConversaModalComponent,
    CadastrarItemConversaModalComponent,
    CadastrarLigacaoTelemarketingModalComponent,
    CadastrarFornecedorEstruturaModalComponent,
    FormulaItemEstruturaModalComponent,
    SimulacaoEstruturaModalComponent,
    DescontoIndividualModalComponent,
    MultiFormaPagamentoModalComponent,
    CadastrarMultiFormaPagamentoModalComponent,
    LigacaoModalComponent,
    TagHistoricoModalComponent,
    KitImagemModalComponent,
    CadastrarKitImagemModalComponent,
    FidelidadeEmailComponent,
    CadastrarFidelidadeEmailComponent,
    DadosMonitoresModalComponent,
    EstoqueProdutoModalComponent,
    PedidosLoteModalComponent,
    MeiosDePagamentoModalComponent,
    AlterarMargemValorFornecedorModalComponent,
    AlterarLiderTimeModalComponent,
    HistoricoDoPrecoModalComponent,
    AdicionarMenuProdutoModalComponent,
    KitsParaExcluirModalComponent,
    OcorrenciaLogRespModalComponent,
    PedidoApelidoModalComponent,
    ProdutoCDModalComponent,
    AnotacaoStatusModalComponent,
    ContaRefModalComponent,
    SelecionarEtapaPedidoModalComponent,
    FiltrosGestaoDeDescontosComponent,
    ListaGestaoDescontoComponent,
    LogFiltrosGestaoDescComponent,
    FiltroClassificacaoPedidosComponent,
    CadastrarSetorModalComponent,
    ConfiguraAppOctopusComponent,
    PagamentoOctopusComponent,
    LotesDoProdutoModalComponent,
    TrocarDeLoteModalComponent,
    TokenPlataformaModalComponent,
    HistoricoEstoqueModalComponent,
    CadastrarPendenciaModalComponent,
    TransferenciaItemsVendedorModalComponent,
    CadastrarNotaFiscalPedidoModalComponent,
    ExportarFretesMultiCDsModalComponent,
    SolicitacoesTokenIntegradorModalComponent,
    IntegradorModalComponent,
    PrecificacaoUFModalComponent,
    CadastrarPrecificacaoUFModalComponent,
    ModalidadeComponent,
    LogsVendaCupomModalComponent,
    LogOcorrenciaComponent,
    AnaliseDescontoSolicitacaoModalComponent,
    FilaAddOperadorModalComponent,
    FilaSelOperadorModalComponent,
    AnaliseDescontoConclusaoModalComponent,
    CadastrarEtapaOcorrenciaModalComponent,
    LogEtapaOcorrenciaModalComponent,
    ListaPendenciaModalComponent,
    FaixaDescargaCifComponent,
    CadastrarFaixaDescargaCifModalComponent,
    CadastrarEtapaRastreioModalComponent,
    RastreioExternoComponent,
    RastreioPedidoModalComponent,
    FornecedorModalComponent,
    ImportarAgrupamentoStringboxModalComponent,
    TermoAceiteModalComponent,
    IndicadoresAnaliseDescontoModalComponent,
    CadastrarAgrupamentoStringboxModalComponent,
    TermoAceiteListaModalComponent,
    SelecionaProdutoV2ModalComponent,
    ImportarTransferenciaVendedoresModalComponent,
    VendaItemLotesModalComponent,
    EnviarEmailModalComponent,
  ],
})
export class ModalsModule {}
